import { render } from "./xt_select.vue?vue&type=template&id=6d9e9d03&scoped=true"
const script = {}

import "./xt_select.vue?vue&type=style&index=0&id=6d9e9d03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9e9d03"]])

export default __exports__